// extracted by mini-css-extract-plugin
module.exports = {"testimonials":"Testimonials_testimonials__maj-a"};